import Button from "component/ui/Button";
import FullPageLoader from "component/ui/fullPageLoader";
import SearchInput from "component/ui/SearchInput";
import { getMaxValue } from "helper/appConstant";
import {
  isViewProfile,
  notification,
  NotificationType,
  REQUEST_STATUS,
} from "helper/constant";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { acceptConnectionRequest } from "store/slice/booking";

// const renderNotificationMessage = (message, handleDetails) => {
//   if (!message) return null;

//   const regex = /\*#_([^*]+)\*|\*#([^*]+)\*/g;

//   const elements = [];
//   let lastIndex = 0;
//   let match;
//   let key = 0;

//   while ((match = regex.exec(message)) !== null) {
//     // Normal text before match
//     console.log("match[1]", match[1]);
//     if (match.index > lastIndex) {
//       elements.push(
//         <span key={key++}>{message.slice(lastIndex, match.index)}</span>
//       );
//     }

//     // Underline → *#_text*
//     if (match[1]) {
//       elements.push(
//         <span
//           onClick={() => {
//             if (match[1]) {
//               handleDetails(match[1]);
//             }
//           }}
//           key={key++}
//           className="underline font-medium cursor-pointer"
//         >
//           {match[1]}
//         </span>
//       );
//     }

//     // Bold → *#text*
//     if (match[2]) {
//       elements.push(
//         <span key={key++} className="font-semibold">
//           {match[2]}
//         </span>
//       );
//     }

//     lastIndex = regex.lastIndex;
//   }

//   // Remaining normal text
//   if (lastIndex < message.length) {
//     elements.push(<span key={key++}>{message.slice(lastIndex)}</span>);
//   }

//   return elements;
// };
const renderNotificationMessage = (message) => {
  if (!message) return null;

  const regex = /\*#_([^*]+)\*|\*#([^*]+)\*/g;
  const elements = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = regex.exec(message)) !== null) {
    const clickableText = match[1]; // underline
    const boldText = match[2]; // bold

    // Normal text
    if (match.index > lastIndex) {
      elements.push(
        <span key={key++}>{message.slice(lastIndex, match.index)}</span>
      );
    }

    // Underlined + clickable
    if (clickableText) {
      elements.push(
        <span key={key++} className="underline font-medium cursor-pointer">
          {clickableText}
        </span>
      );
    }

    // Bold only
    if (boldText) {
      elements.push(
        <span key={key++} className="font-semibold">
          {boldText}
        </span>
      );
    }

    lastIndex = regex.lastIndex;
  }

  // Remaining text
  if (lastIndex < message.length) {
    elements.push(<span key={key++}>{message.slice(lastIndex)}</span>);
  }

  return elements;
};

export default function Notifications({
  //   notification,
  open,
  setNotificationOpen,
  notification,
  setRatingData,
  fetchNotificationList,
  searchQuery,
  setSearchQuery,
  buttonLoading,
  setButtonLoading,
  handleDetails,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const body = document.body;

    if (open) {
      const scrollY = window.scrollY;

      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.width = "100%";
    } else {
      const scrollY = body.style.top;

      body.style.position = "";
      body.style.top = "";
      body.style.width = "";

      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    return () => {
      body.style.position = "";
      body.style.top = "";
      body.style.width = "";
    };
  }, [open]);

  const handleConnectionActionSuccess = (status) => {
    if (status) {
      fetchNotificationList();
    }
    setLoading(false);
  };
  return (
    <div>
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"
          onClick={() => setNotificationOpen(false)}
        />
      )}

      <div
        className={`fixed top-0 right-0 h-full text-black md:w-96 w-80 bg-white shadow-lg z-50 transform transition-transform duration-300
        ${open ? "translate-x-0" : "translate-x-full"}
       `}
      >
        {loading && <FullPageLoader />}
        <div className="p-4 flex justify-between items-center border-b">
          <h2 className="text-xl text-black font-medium">Notifications</h2>
          <button
            className="text-black"
            onClick={() => setNotificationOpen(false)}
          >
            ✕
          </button>
        </div>

        <div className="m-2">
          <SearchInput
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              fetchNotificationList(null, e.target.value);
            }}
            placeholder="Search conversation"
            icon={FiSearch}
          />
        </div>
        {notification?.data?.length > 0 ? (
          <div className="p-2 pb-5 space-y-2 h-[80vh] overflow-y-scroll thin-scrollbar">
            {notification?.data?.map((text, index) => (
              <div
                key={index}
                style={{
                  cursor: text?.cardType ? "pointer" : "",
                }}
                className="p-3 flex items-start gap-3 bg-[#2babe21e] rounded-md shadow-lg
                 transition-transform duration-300 ease-in-out
                 hover:shadow-xl hover:-translate-y-0.5"
              >
                {/* Avatar Container (FIXED WIDTH) */}
                <div className="w-12 shrink-0 flex justify-center">
                  {text?.profileImageUrl ? (
                    <img
                      src={text.profileImageUrl}
                      alt="profile"
                      className="w-10 h-10 object-cover rounded-full"
                    />
                  ) : (
                    <div
                      className="w-10 h-10 bg-highlight text-white
                          flex justify-center items-center
                          font-semibold rounded-full"
                    >
                      {text?.name?.charAt(0)?.toUpperCase()}
                    </div>
                  )}
                </div>

                {/* Message Content */}
                <div className="flex-1">
                  <p
                    className="text-sm text-gray-800 leading-5 break-words"
                    onClick={() => {
                      if (text?.cardType) {
                        handleDetails(text);
                      }
                    }}
                  >
                    {renderNotificationMessage(text?.message)}
                  </p>
                  {isViewProfile(text?.notificationType) &&
                    text?.status != 2 && (
                      <p
                        onClick={() => {
                          navigate(`/player-details/${text?.userId}`);
                          setNotificationOpen(false);
                        }}
                        className="text-sm text-highlight underline cursor-pointer"
                      >
                        View Profile
                      </p>
                    )}
                  <div className="flex gap-2 pt-3">
                    {isViewProfile(text?.notificationType) &&
                      text?.status != REQUEST_STATUS?.ACCEPT_REQUEST && (
                        <Button
                          onClick={() => {
                            setLoading(true);
                            dispatch(
                              acceptConnectionRequest(
                                text?.userId,
                                text?.connectionRequestId,
                                1,
                                handleConnectionActionSuccess
                              )
                            );
                          }}
                          size="xs"
                          className={"mt-1"}
                        >
                          Accept
                        </Button>
                      )}
                    {isViewProfile(text?.notificationType) &&
                      text?.status != REQUEST_STATUS?.ACCEPT_REQUEST &&
                      text?.status != REQUEST_STATUS?.HIDE_BTN_REQUEST && (
                        <Button
                          onClick={() => {
                            setLoading(true);
                            dispatch(
                              acceptConnectionRequest(
                                text?.userId,
                                text?.connectionRequestId,
                                0,
                                handleConnectionActionSuccess
                              )
                            );
                          }}
                          size="xs"
                          className={"mt-1"}
                        >
                          Reject
                        </Button>
                      )}
                  </div>
                  {text?.notificationType ==
                    NotificationType?.VENUE_RATING_NOTIFICATION_TO_USER &&
                    !text?.isVenueRated && (
                      <Button
                        onClick={() => {
                          setNotificationOpen(false);
                          setRatingData({ isShow: true, ...text });
                        }}
                        size="xs"
                        className={"mt-1"}
                      >
                        Rate Venue
                      </Button>
                    )}
                  {text?.notificationType ==
                    NotificationType?.EXPIRED_OR_PAID &&
                    !text?.isExpired &&
                    !text?.isPaid && (
                      <Button size="xs" className={"mt-1"}>
                        {"Pay Amount"}
                      </Button>
                    )}
                  {text?.notificationType ==
                    NotificationType?.EXPIRED_OR_PAID &&
                    (text?.isExpired || text?.isPaid) && (
                      <Button
                        style={{
                          background: text?.isExpired ? "red" : "green",
                        }}
                        size="xs"
                        className={"mt-1"}
                      >
                        {text?.isExpired ? "Expired" : "Paid"}
                      </Button>
                    )}
                  {/* Optional meta */}
                  <p className="text-right text-xs text-gray-500">
                    {text?.notificationDateTime &&
                      moment(text?.notificationDateTime).format(
                        "DD/MM/YYYY hh:mm A"
                      )}
                  </p>
                </div>
              </div>
            ))}
            {/* view more button */}
            {notification?.totalCount > notification?.data?.length && (
              <div className="flex justify-center py-3">
                <Button
                  children={"View More"}
                  isLoading={buttonLoading}
                  onClick={() => {
                    setButtonLoading(true);
                    fetchNotificationList(
                      getMaxValue(notification?.data?.length, 25) + 1
                    );
                  }}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="h-[80vh] flex justify-center items-center">
            No Notifications Available
          </div>
        )}
      </div>
    </div>
  );
}
